import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import WOW from 'wowjs';
import Parallax from 'parallax-js';
import TopNotification from './components/Landing/TopNotification';
import Header from './components/Landing/Header';
import Menu from './components/Landing/Menu';
import BannerSection1 from './components/Landing/BannerSection1';
import BannerSection2 from './components/Landing/About';
import Services from './components/Landing/Services';
import FunFact from './components/Landing/FunFact';
import Team from './components/Landing/Team';
import About from './components/Landing/About';
import Portfolio from './components/Landing/Portfolio';
import FAQ from './components/Landing/FAQ';
import Testimonial from './components/Landing/Testimonial';
import Enquiry from './components/Landing/Enquiry';
import Footer from './components/Landing/Footer';
import Modal from './components/Modal/Modal';
import 'tilt.js';
import { ReactComponent as LoadingIcon } from '../src/cpanel-loading.svg';
import Login from './components/Login/login';
import Captcha from './components/Landing/Captcha';

const Home = () => {

  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  //login signup
  const [isEnquiry, setIsEnquiry] = useState('enquiry');
  const handleIsEnquiry=(value)=>{
        setIsEnquiry(value);
  }
  const handleScroll = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  //Modal for Inquiry
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 30000); // 0.45 minute (45,000ms)

    return () => clearTimeout(timer); 
  }, []);


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // const timer= setTimeout(()=>{
    //   setLoading(false)
    // },500)
    // return ()=> clearTimeout(timer)
    function handlePreloader() {
      if ($('.preloader').length) {
        $('.preloader').delay(200).fadeOut(500);
      }
    }
    handlePreloader();

  }, [])

  useEffect(()=>{
    if ($('.wow').length) {
      var wow = new WOW.WOW(
        {
          boxClass: 'wow',
          animateClass: 'animated', 
          offset: 0,
          mobile: false,
          live: true
        }
      );
      wow.init();
    }
  },[])

  useEffect(()=>{
    
    function onHoverthreeDmovement() {
      var tiltBlock = $('.js-tilt');
      if(tiltBlock.length) {
          $('.js-tilt').tilt({
              maxTilt: 20,
              perspective:700, 
              glare: true,
              maxGlare: 0
          })
      }
  }
  onHoverthreeDmovement();
},[])


useEffect(()=>{
    	//Parallax Scene for Icons
	if($('.parallax-scene-1').length){
		var scene = $('.parallax-scene-1').get(0);
		var parallaxInstance = new Parallax(scene);
	}
	if($('.parallax-scene-2').length){
		var scene = $('.parallax-scene-2').get(0);
		var parallaxInstance = new Parallax(scene);
	}
	if($('.parallax-scene-3').length){
		var scene = $('.parallax-scene-3').get(0);
		var parallaxInstance = new Parallax(scene);
	}
	if($('.parallax-scene-4').length){
		var scene = $('.parallax-scene-4').get(0);
		var parallaxInstance = new Parallax(scene);
	}
	if($('.parallax-scene-5').length){
		var scene = $('.parallax-scene-5').get(0);
		var parallaxInstance = new Parallax(scene);
	}
	if($('.parallax-scene-6').length){
		var scene = $('.parallax-scene-6').get(0);
		var parallaxInstance = new Parallax(scene);
	}
},[])

  return (
    <>
     <div style={{ maxWidth: "100vw" }}>
      {/* <Captcha placeholder={"Enter Captcha"} inputStyle={{
                    backgroundColor: "#fff",
                    border: "1px solid #d2eff3",
                    width: "51.5%",
                    borderRadius: 0,
                    marginTop: "15px",
                    marginLeft: "6.5%",
                    height: "60px" // Match the height of the canvas
                }} canvasHeight={"80"} canvasWidth={"200"} canvasStyle={{backgroundColor: "#aeb8c1", border: "1px solid #d2eff3",borderRadius: 0,marginTop: "15px",}} buttonStyle={{ backgroundColor: "#0267ff", padding: "6px", height: "60px", marginTop: "15px", paddingLeft: "10px", paddingRight: "10px" }} canvasContainerStyle={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} initialSpace={25} fontSize={"20px"} fontFamily={"Roboto mono"} textColor1={"#fff"} textColor2={"#000"} length={6} styles={{ marginLeft: "17px", marginBottom: "25px", display: "flex", alignItems: "center", width: "100%", marginTop: "-10px" }} /> */}
        {/* loader updated by shahin */}
        <div className="preloader" style={{
          display:'flex',
          justifyContent:'center',
          alignItems:'center'
        }}> <LoadingIcon 
      style={{width:'100%', height:'20vh'}} /></div>
        <Header handleIsEnquiry={handleIsEnquiry} isEnquiry={isEnquiry} />
        <Menu />
        <section id="banner-section1">
          <BannerSection1 />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="services">
          <Services />
        </section>
        <section id="overview">
          <Team />
        </section>
        <section id="testimonial">
          <Testimonial />
        </section>
        <section id={isEnquiry==='enquiry'?"enquiry":"login"}>
          <Enquiry isEnquiry={isEnquiry} handleIsEnquiry={handleIsEnquiry}/>
        </section>
        <Footer />
        {isVisible && (
          <button
            className="scroll-top"
            onClick={scrollToTop}
            data-target="html"
          >
         <span className="fa fa-arrow-up" />
          </button>
        )}

        {/* Modal */}
        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)} // Close modal on user action
          >
          </Modal>
        )}
      </div>
    </>
  );
}

export default Home
